module.exports = __webpack_public_path__ + "img/award_prothom_alo_16x9.4f1543d9.png";